import { render, staticRenderFns } from "./CompositeScores.vue?vue&type=template&id=1b0eaf5b&scoped=true&"
import script from "./CompositeScores.vue?vue&type=script&lang=js&"
export * from "./CompositeScores.vue?vue&type=script&lang=js&"
import style0 from "./CompositeScores.vue?vue&type=style&index=0&id=1b0eaf5b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b0eaf5b",
  null
  
)

export default component.exports